"use strict";
exports.__esModule = true;
exports.SecondaryColor = exports.PrimaryColor = void 0;
exports.PrimaryColor = "#949494";
exports.SecondaryColor = "#949494";
//# sourceMappingURL=theme.js.map